module.exports = "<app-category *ngIf=\"showOnFront === 'post'\"></app-category>\n<div *ngIf=\"pageOnFront\" [appBlockContent]=\"pageOnFront\"></div>\n"